<div class="container">
  <p class="text-center fs-3">Liquidacion de operaciones</p>
  <button class="btn btn-secondary" (click)="incSignal1()"> signal1 </button>
  <button class="btn btn-secondary" (click)="incSignal2()"> signal2 </button>
  <p >Signal 1: {{ signal1() }}</p>
  <p >Signal 2: {{ signal2() }} </p>
  <!--
  <p >Signal based on resource: {{ signalBasadaEnResource() }} </p>
-->
  <div class="row border">
    <form
      [formGroup]="formTests"
      class="row gy-2 gx-2 align-items-center"
    >
      <div class="col-auto">
        <button
          type="submit"
          (click)="test1()"
          class="btn btn-outline-primary"
        >
          Hello
        </button>
      </div>
      <div class="col">
        <textarea class="form-control text-sm"  formControlName="output" rows="10"></textarea>
      </div>
    
     
    </form>
  </div>
  <div class="row border">
    <form
      [formGroup]="formTests"
      class="row gy-2 gx-2 align-items-center"
    >
      <div class="col-auto">
        <button
          type="submit"
          (click)="test1Resource()"
          class="btn btn-outline-primary"
        >
          Hello Beta Resource Async
        </button>
      </div>
      <div class="col">
        <textarea class="form-control text-sm"  formControlName="outputResource" rows="10">{{helloValueSignal()}}</textarea>
      </div>
      {{helloValueSignal()}}
     
    </form>
  </div>
  <div class="row border">
    <form
      [formGroup]="formTests"
      class="row gy-2 gx-2 align-items-center"
    >
      <div class="col-auto">
        <button
          type="submit"
          (click)="test2()"
          class="btn btn-outline-primary"
        >
          getUsuarios
        </button>
      </div>
      <div class="col">
        <textarea class="form-control text-sm"  formControlName="output2" rows="10">dfsaffas</textarea>
      </div>
    
     
    </form>
  </div>
</div>
